import logo from './logo.svg';
import './App.css';
import LandingPage from './Home Page/Landing/Components/Landing Page';
import Navbar from './Navbar';
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import BentoBox from './Home Page/Landing/Components/Bento Box';
import Footer from './Footer';
import { FaWhatsapp } from "react-icons/fa";
import { MdLocationOn } from "react-icons/md";
import { SlPhone } from "react-icons/sl";



function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Navbar />
        <div class="floating-contact">

          <a href="tel:+905013341032" class="contact-btn">
            <span class="tooltip">Telefon</span>
            <SlPhone id='phicon' />
          </a>

          <a href="https://maps.app.goo.gl/tGY7oRp4dLjS2Pzh6" target="_blank" class="contact-btn">
            <span class="tooltip">Konum</span>
            <MdLocationOn id='locicon' />
          </a>

          <a href="https://wa.me/905013341032" target="_blank" class="contact-btn">
            <span class="tooltip">WhatsApp</span>
            <FaWhatsapp id='wpicon' />
          </a>

        </div>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>

  );
}

export default App;
